var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { config } from "./Conf";
import { Field } from "./Field";
import { PathFind } from "./PathFind";
import { Ball } from "./Ball";
import { BallSmasher } from "./BallSmasher";
import { gameSpeedDecorator } from "./Decorators";
var Board = /** @class */ (function () {
    /**
     * @param width Board width
     * @param height Board height
     */
    function Board(width, height) {
        this.mainDiv = document.createElement("div");
        this.mainDiv.id = "board";
        this.width = width;
        this.height = height;
        this.fieldsList = [];
        this.ballList = [];
        this.pathFinder = new PathFind();
        this.pathFindingProc = false;
        this.path = [];
        this.ballSmasher = new BallSmasher();
        this.slideEffectBool = false;
        this.init();
    }
    /**
     * {@link Board} class initialization. Adding {@link Field | Fields} events
     */
    Board.prototype.init = function () {
        var _this = this;
        for (var i = 0; i < this.width; i++) {
            var columnDiv = document.createElement("div");
            columnDiv.classList.add('boardColumn');
            this.fieldsList[i] = [];
            var _loop_1 = function (j) {
                var field = new Field(i, j);
                field.div.onclick = (function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var canActive_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(this.slideEffectBool == false)) return [3 /*break*/, 3];
                                if (!field.child) return [3 /*break*/, 1];
                                if (field.child.isActive == false) {
                                    canActive_1 = false;
                                    config.pos.forEach(function (e) {
                                        if (field.x + e.x >= 0 && field.x + e.x < _this.width && field.y + e.y >= 0 && field.y + e.y < _this.height) {
                                            if (_this.fieldsList[field.x + e.x][field.y + e.y].free == true) {
                                                canActive_1 = true;
                                            }
                                        }
                                    });
                                    if (canActive_1) {
                                        this.ballList.forEach(function (e) { return e.removeClass('activeBall'); });
                                        field.child.addClass('activeBall');
                                        field.child.isActive = true;
                                        if (this.startField && this.startField.child) {
                                            this.startField.child.isActive = false;
                                        }
                                        this.startField = field;
                                    }
                                }
                                else {
                                    field.child.removeClass('activeBall');
                                    field.child.isActive = false;
                                    this.startField = undefined;
                                }
                                return [3 /*break*/, 3];
                            case 1:
                                if (!(this.pathFindingProc == true)) return [3 /*break*/, 3];
                                if (!(this.startField && this.startField.child && this.path.length > 0)) return [3 /*break*/, 3];
                                this.startField.child.removeClass('activeBall');
                                this.startField.child.isActive = false;
                                return [4 /*yield*/, this.slideBall()];
                            case 2:
                                _a.sent();
                                setTimeout(function () {
                                    _this.slideEffectBool = false;
                                    _this.fieldsList.forEach(function (e) { return e.forEach(function (x) {
                                        x.removeClass('pathDisplay');
                                        x.restartField();
                                    }); });
                                    var boardScan = _this.boardScan();
                                    boardScan == false ? _this.parent.ballManage() : _this.anyBallOnBoard() == false ? _this.parent.ballManage() : null;
                                }, this.afterMoveTime ? this.afterMoveTime : 0);
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                field.div.onmouseover = function (e) {
                    _this.fieldsList.forEach(function (e) { return e.forEach(function (x) {
                        if (_this.slideEffectBool == false) {
                            x.removeClass('pathDisplay');
                            x.restartField();
                        }
                    }); });
                    if (_this.startField && _this.startField != field) {
                        _this.endField = field;
                        _this.pathFinding();
                    }
                    else {
                        _this.pathFindingProc = false;
                    }
                };
                this_1.fieldsList[i][j] = field;
                columnDiv.appendChild(field.div);
            };
            var this_1 = this;
            for (var j = 0; j < this.height; j++) {
                _loop_1(j);
            }
            this.mainDiv.appendChild(columnDiv);
        }
    };
    /** @inheritdoc */
    Board.prototype.createBalls = function (colors) {
        var allPlaces = this.fieldsList.flatMap(function (cV, i) {
            return cV.map(function (e, j) { return e; });
        }).filter(function (e) { if (e.free) {
            return e;
        } });
        if (allPlaces.length >= colors.length) {
            for (var i = 0; i < colors.length; i++) {
                var field = allPlaces.splice(Math.floor(Math.random() * allPlaces.length), 1)[0];
                var ball = new Ball(colors[i]);
                field.addBall(ball);
                this.ballList.push(ball);
            }
        }
        else {
            this.parent.endGame();
        }
    };
    /**
     * Method calling {@link PathFind}
     */
    Board.prototype.pathFinding = function () {
        if (this.startField && this.endField) {
            this.pathFindingProc = true;
            this.path = this.pathFinder.find(this.startField, this.endField, this.fieldsList);
            this.path.forEach(function (e) {
                e.addClass("pathDisplay");
            });
        }
    };
    /**
     * Method for managing the animation of the {@link Ball}
     * @returns Method result
     */
    Board.prototype.slideBall = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ball, slideEff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.slideEffectBool = true;
                        ball = this.startField.child;
                        this.startField = undefined;
                        this.endField = undefined;
                        this.pathFindingProc = false;
                        if (!(ball != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.slideEffect(ball)];
                    case 1:
                        slideEff = _a.sent();
                        if (slideEff == true) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * Method of moving the {@link Ball} across each {@link Field} of the {@link Board.path | path}
     * @param ball {@link Ball} to move
     * @returns Method result
     */
    Board.prototype.slideEffect = function (ball) {
        var _this = this;
        return new Promise(function (resolv) {
            var i = _this.path.length - 1;
            var slideInterval = setInterval(function () {
                if (i < _this.path.length - 1) {
                    _this.path[i + 1].removeBall();
                    _this.path[i + 1].child = undefined;
                }
                _this.path[i].addBall(ball);
                i--;
                if (i < 0) {
                    clearInterval(slideInterval);
                    resolv(true);
                }
            }, 20);
        });
    };
    /** @inheritdoc */
    Board.prototype.boardScan = function () {
        var toDestroy = this.ballSmasher.checkTab(this.fieldsList);
        toDestroy.forEach(function (e) { e.removeBall(); e.child = undefined; });
        this.parent.addScore(toDestroy.length);
        return toDestroy.length > 0;
    };
    /** @inheritdoc */
    Board.prototype.anyBallOnBoard = function () {
        return this.fieldsList.filter(function (e) { if (e.filter(function (x) { if (x.child) {
            return x;
        } }).length > 0) {
            return e;
        } }).length > 0;
    };
    Board = __decorate([
        gameSpeedDecorator
        /**
         * Class that manages the board and basic game functionalities
         */
        ,
        __metadata("design:paramtypes", [Number, Number])
    ], Board);
    return Board;
}());
export { Board };
